import React, { useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';

import { getGroupAssignment } from '../../actions/survey-actions';
import SurveyHolder from './SurveyHolder';
import CloseSurvey from './CloseSurvey';
import Loading from '../shared/Loading'
import { DefaultLayout, TabsCategory } from '../shared/component'

import { SurveyData, StudentProfile } from '../../utils/services/cache/ClientCache'
import { ConvertDateString } from '../../utils/helpers/dateformat/ConvertDateString'
import { getIconSurvey } from '../../utils/helpers/icon/iconHelper';
import useStyles from '../../styles/components/survey/stylesSurvey'


const Survey = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState(true);
    const [openSurveys, setOpenSurveys] = React.useState([]);
    const [closeSurveys, setCloseSurveys] = React.useState([]);
    const [surveyID, setSurveyID] = React.useState(0)
    const classes = useStyles()
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const onLoadMore = () => setRowsPerPage(rowsPerPage + 5)

    useEffect(() => {
        SurveyData.removeSurveyData();
        initSurvey();
    }, []);

    const initSurvey = async () => {
        let response = await getGroupAssignment(StudentProfile.getStudentId(), StudentProfile.getAuthKey());
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        if (response.status === "Success") {

            let surveys = response.data;
            setIsLoading(false);

            let openSurvey = surveys.filter((value) => {
                let today = new Date();
                let endDate = new Date(ConvertDateString.convertForDatePicker(value.endDate));

                if (today <= endDate && !value.isCompleted) {
                    return value;
                }
                else
                    return null;
            });

            let closeSurvey = surveys.filter((value) => {
                let today = new Date();
                let endDate = new Date(ConvertDateString.convertForDatePicker(value.endDate));
                if (value.isCompleted)
                    return value;
                else if (today > endDate)
                    return value;
                else
                    return null;
            });

            setOpenSurveys(openSurvey);
            setCloseSurveys(closeSurvey);
        }

    };

    const breadcrumbsData = [
        {
            type: 'Survey',
            text: 'Survey Overview',
            href: ''
        },
    ];

    const handleClickSurveyID = useCallback((surveyId) => {
        setSurveyID(surveyId);
    }, [surveyID]);

    const dataTabsCategory = [
        {
            label: 'On-going',
            component: (
                <Grid>
                    <Grid>
                        {
                            openSurveys.length > 0 ?
                                openSurveys.slice(0, rowsPerPage).map((survey) => (
                                    <SurveyHolder
                                        key={survey.surveyId}
                                        survey={survey}
                                        surveyId={surveyID}
                                        handleClickSurveyID={(surveyId) => handleClickSurveyID(surveyId)}
                                    />

                                )) : <></>
                        }
                    </Grid>
                    {
                        rowsPerPage < openSurveys.length &&
                        <Grid classes={{ root: classes.containerLoadmore }} container justify="center" alignItems="center" onClick={() => onLoadMore()}>
                            <div>
                                Load more
                            </div>
                        </Grid>
                    }
                </Grid>
            ),
            description: 'Please select a survey from the list to begin.',
            type: 'Survey',
            breadcrumbsData: breadcrumbsData
        },
        {
            label: 'Closed',
            component: (
                <Grid>
                    <Grid>
                        {
                            closeSurveys.length > 0 ?
                                closeSurveys.slice(0, rowsPerPage).map((survey) => (
                                    <CloseSurvey
                                        key={survey.surveyId}
                                        survey={survey}
                                        handleClickSurveyID={(surveyId) => handleClickSurveyID(surveyId)}
                                        surveyId={surveyID}
                                    />
                                )) : <></>
                        }
                    </Grid>
                    {
                        rowsPerPage < closeSurveys.length &&
                        <Grid classes={{ root: classes.containerLoadmore }} container justify="center" alignItems="center" onClick={() => onLoadMore()}>
                            <div>
                                Load more
                            </div>
                        </Grid>
                    }
                </Grid>
            ),
            description: 'Please select a survey from the list to check completion status.',
            type: 'Survey',
            breadcrumbsData: breadcrumbsData
        }
    ]

    if (isLoading) return <Loading />;

    return (
        <div>
            <DefaultLayout
                title='Survey'
                type='Survey'
                description='Be rewarded with coins when you complete your survey'
                image={getIconSurvey().img_survey_bg}
            >
                <TabsCategory
                    dataTabsCategory={dataTabsCategory}
                />
            </DefaultLayout>
        </div >
    );
};

export default Survey;